import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiUrlBuilder } from '../../config/api.config';
import { AuthService } from '../auth.service';
import { ReferralInfo } from '../../models/referral.model';

@Injectable({ providedIn: 'root' })
export class ReferralApiService {
  readonly http = inject(HttpClient);
  readonly authService = inject(AuthService);

  async getMe(): Promise<ReferralInfo> {
    return firstValueFrom(
      this.http.get<ReferralInfo>(ApiUrlBuilder.referrals('me'), {
        headers: this.authService.getAuthHeaders(),
      }),
    );
  }
}
